<template>
  <div class="ai-review">
    <AiFeedbackPoints
      v-if="review.feedback_bullets.length"
      :points="review.feedback_bullets"
      :type-name="review.type_name || ''"
    />
    <p v-else class="text-body-2">Geen verbeterpunten gevonden.</p>

    <p
      v-if="!review.suggested_rewrite && statusNote"
      class="text-body-2 text-medium-emphasis mt-3 mb-0"
    >
      {{ statusNote }}
    </p>

    <template v-if="review.suggested_rewrite">
      <div class="text-caption text-medium-emphasis mt-4 mb-1">
        Voorgestelde tekst
      </div>
      <AiTextDiff
        :original="review.original_preview"
        :rewrite="review.preview"
      />

      <p v-if="applied" class="text-caption mt-2">
        Tekst overgenomen. Ongedaan maken? Tik in de tekst en gebruik Ctrl+Z
        (Cmd+Z).
      </p>
      <v-alert
        v-else-if="stale"
        type="info"
        variant="tonal"
        density="compact"
        class="mt-2"
      >
        De tekst is gewijzigd sinds de controle. Controleer opnieuw om de
        voorgestelde tekst over te nemen.
      </v-alert>
      <v-alert
        v-else-if="!canApply"
        type="info"
        variant="tonal"
        density="compact"
        class="mt-2"
      >
        Deze tekst kan niet automatisch worden overgenomen, omdat een vermelding
        (@ of #) ontbreekt. Neem eventueel zelf delen over.
      </v-alert>

      <div v-if="!applied" class="d-flex mt-3 ai-suggestion-actions">
        <v-btn
          color="primary"
          class="flex-grow-1"
          prepend-icon="mdi-check"
          :disabled="!canApply"
          @click="$emit('apply')"
        >
          Tekst overnemen
        </v-btn>
      </div>
    </template>

    <div class="d-flex align-center justify-end mt-2">
      <span class="text-caption mr-1">Nuttig?</span>
      <v-btn
        :icon="rating === 1 ? 'mdi-thumb-up' : 'mdi-thumb-up-outline'"
        variant="text"
        aria-label="Nuttig"
        :aria-pressed="rating === 1"
        @click="$emit('rate', 1)"
      />
      <v-btn
        :icon="rating === -1 ? 'mdi-thumb-down' : 'mdi-thumb-down-outline'"
        variant="text"
        aria-label="Niet nuttig"
        :aria-pressed="rating === -1"
        @click="$emit('rate', -1)"
      />
    </div>
  </div>
</template>

<script setup>
/**
 * The text section of the AI-check: feedback bullets and a suggested rewrite the
 * worker can take over in one tap. Never changes the text by itself.
 */
import { computed } from "vue";
import { rewriteStatusNote } from "@/utils/aiRequests";
import AiTextDiff from "./AiTextDiff.vue";
import AiFeedbackPoints from "./AiFeedbackPoints.vue";

const props = defineProps({
  // { feedback_bullets: [{ text, severity }], suggested_rewrite: string, rewrite_status: string,
  //   preview: string, original_preview: string } (previews show mentions as names)
  review: { type: Object, required: true },
  canApply: { type: Boolean, default: false },
  applied: { type: Boolean, default: false },
  // The text changed after the check
  stale: { type: Boolean, default: false },
  rating: { type: Number, default: null },
});

defineEmits(["apply", "rate"]);

// Why there is no rewrite to take over (the server only offers a real one)
const statusNote = computed(() =>
  rewriteStatusNote(props.review.rewrite_status),
);
</script>

<style scoped></style>
